import * as React from "react";

function MapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M30 25.64V1.437L20.333 5.9l-8.666-4L2 6.361v24.202l9.667-4.461 8.666 4L30 25.64zM4 27.437V7.64l6.666-3.076V24.36L4 27.437zm8.666-3.077V4.563l6.667 3.077v19.797l-6.667-3.077zm8.667 3.078V7.64L28 4.563V24.36l-6.667 3.078z",
    clipRule: "evenodd"
  }));
}

export default MapIcon;